import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import LimiteErreurChargement from "./LimiteErreurChargement";
import RepliChargement from "./RepliChargement";

/**
 * Zone où s'affichent des pages chargées à la demande : Suspense (repli
 * léger pendant l'arrivée du code) + limite d'erreur (« Recharger » si le
 * code n'arrive pas). L'erreur est oubliée quand l'adresse change.
 *
 *   pleinePage : repli et erreur occupent toute la fenêtre (autour du
 *                routeur) ; sinon ils restent dans la zone de contenu (la
 *                barre latérale de l'administration reste en place).
 *   groupe     : nom du groupe de pages servi par cette zone (« compte »,
 *                « poche », « equipe »). Changer de groupe crée une zone
 *                NEUVE (clé React) — voir ci-dessous.
 *
 * Pourquoi une zone par groupe de pages : React Router 7 change d'adresse
 * dans une « transition » React. Pendant une transition, React garde
 * l'ANCIEN écran figé tant qu'une zone DÉJÀ AFFICHÉE attend du code : aucun
 * repli, rien ne montre qu'un chargement est en cours (le responsable qui
 * vient de se connecter croit que rien ne s'est passé et reclique). Une zone
 * qui apparaît avec la nouvelle page, elle, montre son repli tout de suite.
 * D'où : chaque groupe chargé à la demande a sa propre zone (App.js), et on
 * ne fige plus jamais l'écran en changeant de groupe. À l'intérieur d'un
 * même groupe (tout son code arrive d'un bloc), la zone est réutilisée :
 * on passe d'une page à l'autre sans clignotement, comme avant.
 */
export default function ZoneChargement({ pleinePage = false, groupe, children }) {
  const { pathname } = useLocation();
  return (
    <LimiteErreurChargement key={groupe} cleReinit={pathname} pleinePage={pleinePage}>
      <Suspense fallback={<RepliChargement pleinePage={pleinePage} />}>{children}</Suspense>
    </LimiteErreurChargement>
  );
}
